export enum OrderTypeOfHome {
  SINGLE_FAMILY = "single_family",
  TOWNHOUSE = "townhouse",
  CONDOMINIUM = "condominium",
  MULTI_FAMILY = "multi_family",
  MANUFACTURED = "manufactured",
  LOT = "lot",
  OTHER = "other",
}
